module.exports = __webpack_public_path__ + "assets/img/4.a7c2745d.jpg";